//@flow
import React, { Component } from 'react'
import SVG from 'react-svg-inline'
import { Route, Switch } from 'react-router-dom'
import { connect } from "react-redux";
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { SETUP_STATES, updateStep } from 'h-signup'
import { Root, Caption, Artboard, Main, LogoContainer, ArtContainer } from './styledComponents'


import { GetStarted, Verify, SetupSm, Success } from '../FormWizard'
import BreadCrumbs from '../BreadCrumbs'
import { fetchUserDetails, setUserInvited} from "../../actions";
import { setupIllustrations, inviteIllustration } from '../../utils'
import hiverLogo from '../../../common/images/hiverLogo.svg'

class SetupContainer extends Component<Props, State> {

    removeBlock: Function;

    constructor(props) {
        super(props);
        const { 
            history,
            location: { search, pathname },
            match: { path },
            fetchUserDetails,
            updateStep,
            setUserInvited
        } = this.props;
        fetchUserDetails();
        const invited = search.match(/invited=true/);

        this.state = {
            userInvited : Boolean(invited)
        }

        if (invited) {
            let redirectURL = `${path}/${SETUP_STATES[3]}`;
            setUserInvited({ isUserInvited: true });
            if (redirectURL && redirectURL !== pathname) {
                history.push(redirectURL);
                updateStep(SETUP_STATES[3]);
            }
        }
    }
    
    componentDidMount() {
        const { progress } = this.props;
        if(this.state.userInvited){
            this.setupRouteTransitionBlock();
            return;
        } else if (progress === -1) {
            this.initiateSetup();
        } else {
            this.syncStateToRoute();
        }   
        this.setupRouteTransitionBlock();
    }

    componentDidUpdate(lastProps) {
        if (lastProps.progress !== this.props.progress)
            this.syncStateToRoute();
    }

    componentWillUnmount() {
        this.removeBlock();
    }

    setupRouteTransitionBlock() {
        this.removeBlock = this.props.history.block((nextLocation) => {
            const { progress } = this.props;
            const { pathname } = nextLocation;
            const subPath = pathname.split(`/${SETUP_STATES[0]}`)[1].substring(1);
            const intendedIndex = SETUP_STATES.indexOf(subPath);
            return intendedIndex >= progress;
        });
    }

    initiateSetup () {
        const { location: { search }, updateStep } = this.props;
        const regex = /usersession=\d+/;
        const matches = search.match(regex);
        if (!matches || !matches.length) return this.syncStateToRoute();
        updateStep(SETUP_STATES[0]);
    }


    syncStateToRoute() {
        const { 
            progress, 
            history, 
            match: { path }, 
            location: { pathname }
        } = this.props;
        let redirectURL;
        if (progress === -1)
            redirectURL = '/';
        else if (progress > 0)
            redirectURL = `${path}/${SETUP_STATES[progress]}`
        else if (progress === 0)
            redirectURL = `${path}`
        if (redirectURL && redirectURL !== pathname) {
            history.push(redirectURL);
        }
    }

    renderArtboard() {
        const { progress, isUserInvited } = this.props;
        if(progress < 0 || progress > (setupIllustrations.length - 1))
            return null;
        const { Illustration, caption, captionWidth, IllustrationStyle } = isUserInvited ? inviteIllustration : setupIllustrations[progress];
        return (
            <Artboard>
                <LogoContainer>
                    <SVG svg={hiverLogo} />
                </LogoContainer>
                <ArtContainer>
                    <Illustration />
                    <Caption width={captionWidth} style={IllustrationStyle}>{caption}</Caption>
                </ArtContainer>
            </Artboard>
        );
    }

    renderBreadCrumbs(progress) {
        const { isUserInvited } = this.props;
        if (isUserInvited) {
            return <div></div>;
        }
        return <BreadCrumbs total={4} progress={progress} />;
    }

    render() {
        const { progress, match } = this.props;
        const { path } = match;
        return <Root>
            { this.renderArtboard() }
            <Main>
                { this.renderBreadCrumbs(progress)}
                <Route render={({ location }) => (
                    <TransitionGroup>
                        <CSSTransition
                            key={location.key}
                            classNames="fade"
                            timeout={300}
                        > 
                        <Switch location={location}>
                            <Route exact path={`${path}/setup`} component={SetupSm} />
                            <Route exact path={`${path}/verify`} component={Verify} />
                            <Route exact path={`${path}/success`} component={Success} />
                            <Route exact path="" component={this.state.userInvited ? Success : GetStarted} />
                        </Switch>
                        </CSSTransition>
                    </TransitionGroup>
                )}/>
            </Main>
        </Root>
    }
}

type Props = {
    fetchUserDetails: Function,
    match: Object,
    history: Object,
    location: Object,
    progress: number,
    updateStep: Function,
    setUserInvited: Function,
    isUserInvited: Boolean
}

type State = {
    userInvited: Boolean
}

const mapStateToProps = ({ userDetails, signUp: { progress } }) => ({
    progress,
    isUserInvited: userDetails.isUserInvited
});

const mapDispatchToProps = (dispatch: Function) => ({
    fetchUserDetails: () => dispatch(fetchUserDetails()),
    updateStep: step => dispatch(updateStep(step)),
    setUserInvited: invited => dispatch(setUserInvited(invited)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SetupContainer);
